import 'babel-polyfill';
import '@/scss/index.scss';
import Vue from 'vue';
import 'locale-compare-polyfill';
import '@/plugins/axios';
import '@/plugins/element-ui';
import '@/plugins/vue-cookie';
import '@/plugins/vue-currency-filter';
import '@/plugins/pluralize';
import '@/plugins/innersvg-polyfill';
import '@/plugins/infinite-scroll';
import '@/plugins/moment';
import '@/plugins/v-money';
import '@/plugins/placeholder-dash';
import '@/plugins/convert-date';
import '@/plugins/vue-awesome';
import '@/plugins/phone-mask';
import i18n from '@/plugins/vue-i18n';
import { sync } from 'vuex-router-sync';
import App from './App.vue';
import router from './router';
import store from './store/store';
import {routeTracker} from "@/services/route-tracker";

sync(store, router);

Vue.config.productionTip = false;

routeTracker.init();

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
